import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@clerk/clerk-react";
import LoadingSpinner from "@/components/common/LoadingSpinner";

interface ProtectedRouteProps {
  children: React.ReactNode;
  roles?: string[];
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();
  const { isSignedIn, isLoaded } = useAuth();

  // Show loading spinner while checking authentication
  if (!isLoaded) {
    return <LoadingSpinner />;
  }

  // Redirect to login if not authenticated
  if (!isSignedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // TODO: Add role-based access control if roles are specified
  // This would require fetching user profile from Convex to get role
  // if (roles && user && !roles.includes(user.role)) {
  //   return <Navigate to="/unauthorized" replace />
  // }

  return <>{children}</>;
}
